import React, { useState } from 'react';

import { MenuItem, TextField } from 'components';

import { FONT_FAMILIES } from '../../../DocumentViewer/Wrappers/fontFamily';

const OPTIONS = FONT_FAMILIES.map(option => (
  <MenuItem
    key={option.key}
    value={option.key}
    sx={{ fontFamily: option.value }}
  >
    {option.label}
  </MenuItem>
));

type Props = {
  label: string;
  onChange: (value: null | string) => void;
  defaultValue: null | string;
};

export const NullableFontFamily: React.FC<Props> = ({
  label,
  onChange,
  defaultValue,
}) => {
  const [value, setValue] = useState(defaultValue ?? 'inherit');
  return (
    <TextField
      select
      variant="standard"
      label={label}
      value={value}
      onChange={ev => {
        const value = ev.target.value;
        setValue(value);
        onChange(value === null ? null : value);
      }}
    >
      <MenuItem value="inherit">Match email settings</MenuItem>
      {OPTIONS}
    </TextField>
  );
};
